import { render, staticRenderFns } from "./CreateMetaLeadChannel.vue?vue&type=template&id=26275780&scoped=true"
import script from "./CreateMetaLeadChannel.vue?vue&type=script&lang=js"
export * from "./CreateMetaLeadChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateMetaLeadChannel.vue?vue&type=style&index=0&id=26275780&prod&lang=scss&scoped=true"
import style1 from "./CreateMetaLeadChannel.vue?vue&type=style&index=1&id=26275780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26275780",
  null
  
)

export default component.exports